<a class="download-zip-link" #downloadReportesLink aria-label="Descargar reporte"></a>

<section class="table-page table-page--compact riesgos-detail-page">
  <div class="table-page__hero">
    <div class="table-page__copy">
      <h1>Consulta de Riesgos</h1>
      <p>{{ proyectoSeleccionado?.nombre || ("Proyecto #" + (proyectoSeleccionado?.id || "-")) }}</p>
    </div>

    <div class="table-page__toolbar-actions">
      <button mat-raised-button type="button" class="btn table-page__icon-btn table-page__icon-btn--secondary"
        (click)="regresar()">
        <mat-icon>arrow_back</mat-icon>
        <span>Regresar</span>
      </button>

      <button mat-raised-button type="button" class="btn table-page__primary-btn" (click)="descargarProyecto()">
        <mat-icon>download</mat-icon>
        <span>Descargar</span>
      </button>
    </div>
  </div>

  <section class="table-page__card">
    <div class="table-page__table-wrap">
      <table class="table-page__table table-page__table--wide" *ngIf="listRiesgos.length > 0; else riesgosEmptyState">
        <thead>
          <tr>
            <th>Riesgo</th>
            <th>Clasificación</th>
            <th>Plan de respuesta</th>
            <th>Responsable</th>
            <th>Fecha</th>
            <th class="table-page__actions-head table-page__actions--multi">Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of listRiesgos">
            <td>
              <div class="table-page__cell-stack">
                <strong class="table-page__name">Riesgo #{{ row.id }}</strong>
                <span class="table-page__description riesgos-detail-page__summary">
                  {{ row.descripcion || "Sin descripción" }}
                </span>
                <span class="table-page__subtext">
                  Causa raíz: {{ row.causa_raiz || "Sin causa raíz" }}
                </span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__status-badge" [ngClass]="getSeverityClass(row)">
                  {{ getSeverityLabel(row) }}
                </span>
                <span class="table-page__subtext">{{ getRiskPhase(row) }}</span>
                <span class="table-page__subtext">Probabilidad: {{ getProbabilityLabel(row) }}</span>
              </div>
            </td>
            <td>
              <div class="table-page__cell-stack">
                <span class="table-page__text">{{ getResponseStrategy(row) }}</span>
                <span class="table-page__subtext">Periodicidad: {{ getPeriodicityLabel(row) }}</span>
                <span class="table-page__description riesgos-detail-page__summary">
                  {{ getActionsSummary(row) }}
                </span>
              </div>
            </td>
            <td>
              <span class="table-page__text">{{ row.responsable_recurso || "Sin responsable" }}</span>
            </td>
            <td>
              <span class="table-page__text">{{ getDateLabel(row) }}</span>
            </td>
            <td class="table-page__actions table-page__actions--multi">
              <div class="table-page__action-group">
                <button type="button" class="table-page__action-btn" matTooltip="Editar riesgo"
                  (click)="openModRiesgo(row)">
                  <i class="material-icons">edit</i>
                </button>
                <button type="button" class="table-page__action-btn" matTooltip="Agregar seguimiento"
                  (click)="agregarSeguimiento(row)">
                  <i class="material-icons">timeline</i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>

      <ng-template #riesgosEmptyState>
        <div class="table-page__empty" *ngIf="!loading; else riesgosLoadingState">
          <i class="material-icons">warning_amber</i>
          <strong>No se encontraron riesgos</strong>
          <span>Registre un riesgo para este proyecto o verifique el periodo consultado.</span>
        </div>
      </ng-template>

      <ng-template #riesgosLoadingState>
        <div class="table-page__empty table-page__empty--loading">
          <i class="material-icons">hourglass_top</i>
          <strong>Cargando riesgos...</strong>
        </div>
      </ng-template>
    </div>

    <div class="table-page__footer" *ngIf="showPagination">
      <div class="table-page__meta">
        <span>Mostrando {{ rangeEnd }} de {{ totalRegistros }} riesgos</span>
        <span>Página {{ currentPage }} de {{ totalPages || 1 }}</span>

        <label class="table-page__page-size">
          <span>Ver:</span>
          <select [ngModel]="pageSize" (ngModelChange)="onPageSizeChange($event)">
            <option *ngFor="let option of pageSizeOptions" [ngValue]="option">{{ option }}</option>
          </select>
        </label>
      </div>

      <div class="table-page__pager" *ngIf="totalPages > 0">
        <button type="button" class="table-page__pager-link" (click)="firstPage()" [disabled]="currentPage === 1">
          Inicio
        </button>
        <button type="button" class="table-page__pager-link" (click)="previousPage()"
          [disabled]="currentPage === 1">
          Anterior
        </button>

        <ng-container *ngFor="let item of getPaginationItems()">
          <button *ngIf="isPageNumber(item); else riesgosDetailPagerEllipsis" type="button"
            class="table-page__pager-page" [class.is-current]="item === currentPage" (click)="onPageChange(item)">
            {{ item }}
          </button>

          <ng-template #riesgosDetailPagerEllipsis>
            <span class="table-page__pager-ellipsis">...</span>
          </ng-template>
        </ng-container>

        <button type="button" class="table-page__pager-link" (click)="nextPage()"
          [disabled]="currentPage === totalPages">
          Siguiente
        </button>
        <button type="button" class="table-page__pager-link" (click)="lastPage()"
          [disabled]="currentPage === totalPages">
          Último
        </button>
      </div>
    </div>
  </section>
</section>
